import { render, staticRenderFns } from "./ArrowButton.vue?vue&type=template&id=02f146aa&scoped=true"
import script from "./ArrowButton.vue?vue&type=script&lang=js"
export * from "./ArrowButton.vue?vue&type=script&lang=js"
import style0 from "./ArrowButton.vue?vue&type=style&index=0&id=02f146aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f146aa",
  null
  
)

export default component.exports